import(/* webpackMode: "eager" */ "/app/node_modules/@portals/hc-rich-editor/lib/data-parser/_components/block/_components/alert-block/assets/icons/alert-circle.svg");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@portals/hc-rich-editor/lib/data-parser/_components/block/_components/alert-block/assets/icons/info.svg");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@portals/hc-rich-editor/lib/data-parser/_components/block/_components/alert-block/assets/icons/tips-and-updates.svg");
;
import(/* webpackMode: "eager", webpackExports: ["FaqExpandHeader"] */ "/app/node_modules/@portals/hc-rich-editor/lib/data-parser/_components/block/_components/faq-block/_components/faq-expand-header/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["CollapsibleHeader"] */ "/app/node_modules/@portals/hc-rich-editor/lib/data-parser/_components/collapsible-container/_components/collapsible-header/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["LinkButton"] */ "/app/node_modules/@portals/hc-rich-editor/lib/data-parser/_components/data-header/_components/link-button/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["ExpandPanel"] */ "/app/node_modules/@portals/hc-rich-editor/lib/data-parser/_components/expand-panel/expand-panel.js");
;
import(/* webpackMode: "eager", webpackExports: ["ImageModal"] */ "/app/node_modules/@portals/hc-rich-editor/lib/data-parser/_components/image/_components/image-modal/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@portals/hc-rich-editor/lib/data-parser/_components/link/_components/client-browser-link/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["ListContainer"] */ "/app/node_modules/@portals/hc-rich-editor/lib/data-parser/_components/list/_components/list-container/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationButton"] */ "/app/node_modules/@portals/hc-rich-editor/lib/navigation-list/_components/navigation-button/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@portals/help-center-core/lib/_internal/_ui/internal-absolute-button/_components/button-tooltip/assets/pink-star.svg");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@portals/help-center-core/lib/_internal/_ui/internal-help-center-drawer/_components/advice-list-content/_components/advice-list-tabs/components/advice-tab-article-list/components/advice-item/_components/material-card/_assets/images/material-abstract/1.svg");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@portals/help-center-core/lib/_internal/_ui/internal-help-center-drawer/_components/advice-list-content/_components/advice-list-tabs/components/advice-tab-article-list/components/advice-item/_components/material-card/_assets/images/material-abstract/10.svg");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@portals/help-center-core/lib/_internal/_ui/internal-help-center-drawer/_components/advice-list-content/_components/advice-list-tabs/components/advice-tab-article-list/components/advice-item/_components/material-card/_assets/images/material-abstract/11.svg");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@portals/help-center-core/lib/_internal/_ui/internal-help-center-drawer/_components/advice-list-content/_components/advice-list-tabs/components/advice-tab-article-list/components/advice-item/_components/material-card/_assets/images/material-abstract/12.svg");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@portals/help-center-core/lib/_internal/_ui/internal-help-center-drawer/_components/advice-list-content/_components/advice-list-tabs/components/advice-tab-article-list/components/advice-item/_components/material-card/_assets/images/material-abstract/13.svg");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@portals/help-center-core/lib/_internal/_ui/internal-help-center-drawer/_components/advice-list-content/_components/advice-list-tabs/components/advice-tab-article-list/components/advice-item/_components/material-card/_assets/images/material-abstract/14.svg");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@portals/help-center-core/lib/_internal/_ui/internal-help-center-drawer/_components/advice-list-content/_components/advice-list-tabs/components/advice-tab-article-list/components/advice-item/_components/material-card/_assets/images/material-abstract/15.svg");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@portals/help-center-core/lib/_internal/_ui/internal-help-center-drawer/_components/advice-list-content/_components/advice-list-tabs/components/advice-tab-article-list/components/advice-item/_components/material-card/_assets/images/material-abstract/16.svg");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@portals/help-center-core/lib/_internal/_ui/internal-help-center-drawer/_components/advice-list-content/_components/advice-list-tabs/components/advice-tab-article-list/components/advice-item/_components/material-card/_assets/images/material-abstract/17.svg");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@portals/help-center-core/lib/_internal/_ui/internal-help-center-drawer/_components/advice-list-content/_components/advice-list-tabs/components/advice-tab-article-list/components/advice-item/_components/material-card/_assets/images/material-abstract/18.svg");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@portals/help-center-core/lib/_internal/_ui/internal-help-center-drawer/_components/advice-list-content/_components/advice-list-tabs/components/advice-tab-article-list/components/advice-item/_components/material-card/_assets/images/material-abstract/19.svg");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@portals/help-center-core/lib/_internal/_ui/internal-help-center-drawer/_components/advice-list-content/_components/advice-list-tabs/components/advice-tab-article-list/components/advice-item/_components/material-card/_assets/images/material-abstract/2.svg");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@portals/help-center-core/lib/_internal/_ui/internal-help-center-drawer/_components/advice-list-content/_components/advice-list-tabs/components/advice-tab-article-list/components/advice-item/_components/material-card/_assets/images/material-abstract/20.svg");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@portals/help-center-core/lib/_internal/_ui/internal-help-center-drawer/_components/advice-list-content/_components/advice-list-tabs/components/advice-tab-article-list/components/advice-item/_components/material-card/_assets/images/material-abstract/3.svg");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@portals/help-center-core/lib/_internal/_ui/internal-help-center-drawer/_components/advice-list-content/_components/advice-list-tabs/components/advice-tab-article-list/components/advice-item/_components/material-card/_assets/images/material-abstract/4.svg");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@portals/help-center-core/lib/_internal/_ui/internal-help-center-drawer/_components/advice-list-content/_components/advice-list-tabs/components/advice-tab-article-list/components/advice-item/_components/material-card/_assets/images/material-abstract/5.svg");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@portals/help-center-core/lib/_internal/_ui/internal-help-center-drawer/_components/advice-list-content/_components/advice-list-tabs/components/advice-tab-article-list/components/advice-item/_components/material-card/_assets/images/material-abstract/6.svg");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@portals/help-center-core/lib/_internal/_ui/internal-help-center-drawer/_components/advice-list-content/_components/advice-list-tabs/components/advice-tab-article-list/components/advice-item/_components/material-card/_assets/images/material-abstract/7.svg");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@portals/help-center-core/lib/_internal/_ui/internal-help-center-drawer/_components/advice-list-content/_components/advice-list-tabs/components/advice-tab-article-list/components/advice-item/_components/material-card/_assets/images/material-abstract/8.svg");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@portals/help-center-core/lib/_internal/_ui/internal-help-center-drawer/_components/advice-list-content/_components/advice-list-tabs/components/advice-tab-article-list/components/advice-item/_components/material-card/_assets/images/material-abstract/9.svg");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@portals/help-center-core/lib/_internal/_ui/internal-help-center-drawer/_components/advice-list-content/_components/feedback-success-modal/_assets/icons/blue-bubbles.svg");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@portals/help-center-core/lib/_internal/_ui/internal-help-center-drawer/_components/advice-list-content/_components/feedback-success-modal/_assets/icons/orange-star.svg");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@portals/help-center-core/lib/_internal/_ui/internal-help-center-drawer/_components/advice-list-content/_components/search-input/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@portals/help-center-core/lib/_internal/_ui/internal-help-center-drawer/_components/advice-list-content/_components/stub/_assets/images/ghost-image.png");
;
import(/* webpackMode: "eager", webpackExports: ["RutubeAnalytic"] */ "/app/node_modules/@portals/help-center-core/lib/_internal/_ui/rutube-player/_components/rutube-analytic.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/app/node_modules/react-error-boundary/dist/react-error-boundary.esm.js");
;
import(/* webpackMode: "eager" */ "/app/public/icons/by.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/cn.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/kz.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/map-bg.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/others.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/ru.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/tj.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/app-qr-code.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/jam.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/mobile-app-phone-screen/en.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/mobile-app-phone-screen/ru.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/person-1.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/person-2.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/person-3.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/person-4.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/person-5.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/slides/en/card1-slide1.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/slides/en/card1-slide2.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/slides/en/card1-slide3.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/slides/en/card1-slide4.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/slides/en/card1-slide5.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/slides/en/card1-slide6.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/slides/en/card2-slide1.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/slides/en/card2-slide2.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/slides/en/card2-slide3.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/slides/en/card2-slide4.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/slides/en/card3-slide1.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/slides/en/card3-slide2.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/slides/en/card3-slide3.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/slides/en/card3-slide4.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/slides/en/card3-slide5.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/slides/en/card3-slide6.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/slides/ru/card1-slide1.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/slides/ru/card1-slide2.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/slides/ru/card1-slide3.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/slides/ru/card1-slide4.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/slides/ru/card1-slide5.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/slides/ru/card1-slide6.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/slides/ru/card2-slide1.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/slides/ru/card2-slide2.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/slides/ru/card2-slide3.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/slides/ru/card2-slide4.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/slides/ru/card3-slide1.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/slides/ru/card3-slide2.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/slides/ru/card3-slide3.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/slides/ru/card3-slide4.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/slides/ru/card3-slide5.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/slides/ru/card3-slide6.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/success-stories/1.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/success-stories/2.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/success-stories/3.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/success-stories/4.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/success-stories/6.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/wb-partners-logo.svg");
;
import(/* webpackMode: "eager" */ "/app/src/_components/basket-image/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CallToActionObserver"] */ "/app/src/_components/call-to-action/_components/call-to-action-observer/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/_components/call-to-action/index.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/_components/custom-header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CountryCircle"] */ "/app/src/_components/development-with-wb/_components/country-circle/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DevelopmentWithWbObserver"] */ "/app/src/_components/development-with-wb/_components/development-with-wb-observer/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/_components/education/_components/education-program/index.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/_components/education/index.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/_components/mobile-app/_components/mobile-view/index.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/_components/mobile-app/_components/desktop-view/index.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/_components/mobile-app/index.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/_components/support/_components/support-card/index.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/_components/support/index.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/_components/promo-zone/index.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/_components/development-with-wb/index.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/_components/success-stories/index.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["DiagonalArrowRightIcon"] */ "/app/src/_kit/icons/diagonal-arrow-right-icon/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/_kit/text/index.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/_components/development-with-wb/_components/map/index.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["EducationObserver"] */ "/app/src/_components/education/_components/education-observer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AllMaterialsButton"] */ "/app/src/_components/education/_components/education-program/_components/all-materials-button/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/app/src/_components/education/_components/education-program/_components/link/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProWbLink"] */ "/app/src/_components/education/_components/pro-wb-link/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/_components/footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HowToStart"] */ "/app/src/_components/how-to-start/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoginButton"] */ "/app/src/_components/login-button/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ApplicationStoreLink"] */ "/app/src/_components/mobile-app/_components/desktop-view/_components/application-store-link/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileAppObserver"] */ "/app/src/_components/mobile-app/_components/mobile-app-observer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DownloadButton"] */ "/app/src/_components/mobile-app/_components/mobile-view/_components/download-button/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Preview"] */ "/app/src/_components/preview/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Card"] */ "/app/src/_components/promo-zone/_components/card/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Slider"] */ "/app/src/_components/success-stories/_components/slider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SuccessStoriesObserver"] */ "/app/src/_components/success-stories/_components/success-stories-observer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AllMaterialsButton"] */ "/app/src/_components/support/_components/support-card/_components/all-materials-button/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/app/src/_components/support/_components/support-card/_components/link/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SupportObserver"] */ "/app/src/_components/support/_components/support-observer/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/_components/temp-nav-buttons/index.tsx");
